<template>
  <router-link :to="{ name: 'ContactCaseView', params: { id: Number.isInteger(local_case.contact) ? local_case.contact : local_case.contact.id, case: local_case.id } }">
	<div
		class="contactPreviewCard"
		:class="{'inset': inset}"
	>
		<v-layout
			row
			wrap
		>
			<div
				v-if="!inset"
				style="background:rgba(0,0,0,0.05);border-radius:25px;padding:4px;margin: 10px;aspect-ratio: 1/1;width:32.5px;height:32.5px;"
			>
				<v-icon>
					mdi-briefcase
				</v-icon>
			</div>
			<div
				v-if="!searching"
			>
				<span
					style="font-weight: bold;"
					:class="{'small-title': inset}"
				>
					{{ local_case.case_type.name }}<br />
				</span>
				<span
					v-if="local_case.case_number"
				>
					{{ local_case.case_number }}<br />
				</span>
				<span
					v-if="local_case.case_title"
				>
					{{ local_case.case_title }}<br />
				</span>
			</div>
		</v-layout>
	</div>
  </router-link>
</template>

<script>
import api from '@/api'

export default {
    name: 'CasePreview',
    props: ['xcase', 'id', 'inset'],
    data () {
      return {
        local_case: null,
        searching: false
      }
    },
    created () {
        if (this.xcase) {
            this.local_case = JSON.parse(JSON.stringify(this.xcase))
            if (Number.isInteger(this.local_case.case_type))
                this.loadCaseType()
        } else {
            if (this.id)
                this.loadCase()
        }
    },
    methods: {
        loadCase () {
            this.searching = true
            api.cases.cases.get(this.id)
                .then(data => {
                    this.searching = false
                    this.local_case = data
                })
        },
        loadCaseType () {
            this.searching = true
            api.cases.casetype.get(this.local_case.case_type)
                .then(data => {
                    this.local_case.case_type = data
                    this.searching = false
                })
        }
    }
}
</script>

<style scoped>
.contactPreviewCard {
    background:rgba(0,0,0,0.05);
    padding:5px;
    border-radius:5px;
    cursor: pointer;
}
.contactPreviewCard:hover {
    background:rgba(0,0,0,0.1);
}

.inset {
    background: unset;
}

.small-title {
    font-size: 12px !important;
    font-weight: 900 !important;
}

a {
    text-decoration: none;
    color: black;
}
</style>